import * as React from "react";
import APIClient from "web_modules/APIClient";
import DoubleClickToEdit from "web_modules/shared/DoubleClickToEdit";

const styles = require("./styles.module.scss");

interface BorrowerEmailUpdaterProps {
  borrowerId: number;
}

const BorrowerEmailUpdater: React.FC<BorrowerEmailUpdaterProps> = (
  props: BorrowerEmailUpdaterProps,
) => {
  const { borrowerId } = props;
  const [borrower, setBorrower] = React.useState(null);

  React.useEffect(() => {
    APIClient.get(`/uw/borrowers/${borrowerId}`).then((response: any) => {
      setBorrower(response.borrower);
    });
  }, [borrowerId]);

  function updateBorrowerEmail(borrower_id: number, borrower_email: string): Promise<any> {
    return APIClient.put(`/uw/borrowers/${borrower_id}`, { email: borrower_email })
      .then((response: any) => {
        setBorrower(response.borrower);
      })
      .catch(err => {
        alert(`Error! Couldn't update email! \n\n${err.meta && err.meta.error_detail}`);
      });
  }

  return borrower && borrower.email ? (
    <div className={styles.borrowerEmailUpdater}>
      <li>Double-click below to change a borrower's login email address.</li>
      <DoubleClickToEdit
        acceptedInput="text"
        value={borrower.email}
        onSave={value => {
          return updateBorrowerEmail(borrowerId, value);
        }}
      />
    </div>
  ) : (
    <>Borrower Login Email Address is unavailable</>
  );
};

export default BorrowerEmailUpdater;
